export default "__VITE_ASSET__BuaFAC0l__"